import _ from 'underscore';
import { FilterLinkAdExtension } from '@bingads-webui-campaign/campaign-ui-schemas';
import { panelDecorator } from '@bingads-webui-campaign-react/panel-decorator';
import SchedulingView from '@bingads-webui-campaign-legacy/adextension-shared/view/scheduling';
import { Headers } from '@bingads-webui-campaign-legacy/adextension-structuredsnippet/model/model';
import AssociationsEditorBase from '@bingads-webui-campaign-legacy/adextension-associations-editor/view/index';
import dialogDecorator from '@bingads-webui-component-legacy/dialog/dialogDecorator';
import _SharedRepository from '@bingads-webui-campaign-legacy/adextension-shared/service/repository';

const $i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/adextensions');
const legacyI18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/adextensions');
// This i18n use {0} for template
// This i18n use {{prop_name}} for template

const SharedRepository = _SharedRepository.default || _SharedRepository;

const dialogOptions = { position: 'center', maxWidth: 1000 };

/* eslint-disable camelcase */
const i18nKeys = {
  title: 'AdExtensions_FilterLink_Editor_Title',
  subtitle: ['NewCampaign_FilterLinkAdExtension_Subtitle'],
  library_title: 'AdExtensions_FilterLink_Editor_Available',
  selected_title: 'AdExtensions_FilterLink_Editor_Selected',
  create_link: 'AdExtensions_FilterLink_Editor_CreateNew',
  create_title: 'AdExtensions_FilterLink_Dialog_Title_Add',
  delete_btn: 'AdExtensions_FilterLink_Editor_Delete',
  delete_confirm: 'AdExtensions_FilterLink_Delete_Warning',
  edit_btn: 'AdExtensions_FilterLink_Editor_Edit',
  edit_title: 'AdExtensions_FilterLink_Dialog_Title_Edit',
  inlineAlert: 'AdExtensions_FilterLink_Max_Select_Notification',
};
/* eslint-enable camelcase */

const defaultRepositoryFactory = function (factoryOptions) {
  return new SharedRepository(factoryOptions);
};

const FilterLinkAssociationEditor = AssociationsEditorBase.extend({
  initialize(options) {
    const EditorView = options.vnextContext.dynamicFeatures.DynamicFilterLinkExtensionEditor;
    const Editor = options && options.usePanel ? panelDecorator(EditorView,
      {
        i18n: $i18n,
        panelReadyAriaLabel: $i18n.getString('Association editor side panel opened'),
        panelClassName: options.panelClassName,
      }) :
      dialogDecorator.decorate(EditorView, dialogOptions);
    const repositoryFactory = options.repositoryFactory || defaultRepositoryFactory;

    _.extend(options, {
      idField: 'Id',
      data: repositoryFactory(_.extend({
        schema: FilterLinkAdExtension,
      }, options.vnextContext.dynamicFeatures.repositoryOptions)),
      template: {
        previewTemplateType: 'function',
        preview: options.vnextContext.dynamicFeatures.universalItemTemplate,
        rowTemplate: options.vnextContext.dynamicFeatures.universalItemTemplate,
      },
      extensionType: 'FilterLinkExtension',
      maxSelectedItemsCount: options.maxSelectedItemsCount || 20,
      CreateForm: Editor,
      EditForm: Editor,
      extraEditorOptions: {
        legacyI18n,
        deps: {
          SchedulingView,
          Headers: Headers.default ? Headers.default : Headers,
        },
      },
      i18nKeys: _.extend({}, i18nKeys, options.i18nKeys || {}),
    });
    AssociationsEditorBase.prototype.initialize.apply(this, [options]);
  },
});

export default FilterLinkAssociationEditor;
